export const UHQM_SIDEBAR_ANIMATION_DURATION = 200
export const UHQM_SESSION_STORAGE_KEY = 'uhqm-navigation-state-restore'
export const HELPBOT_SESSION_STORAGE_KEY = 'helpbot-state-restore'
export const MP_UI_TOPBAR_HEIGHT = 71 // topbar + separator
export const APP_CONTAINER_SELECTOR_FRAMEWORK = '#mpui-fw-main-section'
export const RESTRUCTURING_HELP_TOOL_FEATURE_FLAG = 'help-tool-restructuring-is-enabled'

export const SECOND_MS = 1000
export const MINUTE_MS = 60 * SECOND_MS
export const HOUR_MS = 60 * MINUTE_MS
export const DAY_MS = 24 * HOUR_MS
